import { useContext } from 'react';

import CheckboxGroupContext from './CheckboxGroup.context';

const useCheckboxGroup = () => {
  return useContext(CheckboxGroupContext);
};

export default useCheckboxGroup;
